import { Box } from "@mui/material";
import Carousel from "components/carousel/Carousel";
import CategorySectionCreator from "components/CategorySectionCreator";
import useWindowSize from "hooks/useWindowSize";
import { FC, useEffect, useState } from "react";
import ProductCard1 from "components/product-cards/ProductCard1";
import MemoryIcon from "@mui/icons-material/Memory";
import { Paragraph } from "components/Typography";
import BazarButton from "components/BazarButton";
import LazyImage from "components/LazyImage";
import { FlexBox } from "components/flex-box";
import { Product } from "modules/products/types";
import { useLinkHandler } from "hooks";

// =============================================================
type Props = {
  withBundle?: number;
  isForDialog?: boolean;
  cpuProductName?: string;
  compatibleMotherboards?: Product[];
};
// =============================================================

const CompatibleMotherboardCarousel: FC<Props> = ({
  withBundle = 0,
  isForDialog,
  cpuProductName,
  compatibleMotherboards = [],
}) => {
  const [visibleSlides, setVisibleSlides] = useState(4);
  const width = useWindowSize();
  const { openFacebookPage } = useLinkHandler();

  useEffect(() => {
    if (width < 500) setVisibleSlides(1);
    else if (width < 650) setVisibleSlides(2);
    else if (width < 950) setVisibleSlides(3);
    else if (isForDialog) setVisibleSlides(3);
    else setVisibleSlides(4);
  }, [width, isForDialog]);

  return (
    <CategorySectionCreator
      sx={{ marginTop: 3 }}
      icon={<MemoryIcon color="secondary" fontSize="small" />}
      title={
        cpuProductName && compatibleMotherboards?.length > 0
          ? `Compatible Motherboard(s) for ${cpuProductName}`
          : undefined
      }
      titleFontSize="medium"
    >
      {compatibleMotherboards?.length > 0 ? (
        <Carousel
          showArrow
          infinite={false}
          showArrowOnHover
          totalSlides={compatibleMotherboards?.length || 1}
          visibleSlides={visibleSlides}
        >
          {compatibleMotherboards?.map((item, ind) => (
            <Box key={ind} sx={{ p: 0.5 }}>
              <ProductCard1 hoverEffect productData={item} />
            </Box>
          ))}
        </Carousel>
      ) : withBundle ? (
        <FlexBox
          mt={1}
          flexDirection="row"
          justifyContent="center"
          alignItems="center"
        >
          <LazyImage
            width={120}
            height={120}
            layout="fixed"
            objectFit="contain"
            src="/assets/images/shock_red_hair.png"
          />
          <FlexBox flexDirection="column" ml={2}>
            <Paragraph mb={1} textAlign="center">
              Compatible motherboard(s) for this CPU is out of stock. You can
              remove this on cart or lessen quantity. Please contact us directly
              on our facebook page to buy this.
            </Paragraph>

            <BazarButton
              type="submit"
              color="primary"
              variant="contained"
              onClick={() => openFacebookPage()}
              sx={{ mt: 2, backgroundColor: "#CF151A" }}
            >
              Contact Us
            </BazarButton>
          </FlexBox>
        </FlexBox>
      ) : null}
    </CategorySectionCreator>
  );
};

export default CompatibleMotherboardCarousel;
